import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-card p-10 max-w-md text-center">
        <XCircle className="w-16 h-16 mx-auto text-[color:var(--terracotta)] mb-4" />
        <h1 className="font-heading text-2xl font-bold mb-2">Checkout cancelled</h1>
        <p className="text-[color:var(--text-secondary)] mb-6">No charge was made. You can upgrade anytime.</p>
        <Link to="/settings" className="gold-btn px-6 py-3 rounded-full inline-block">Back to settings</Link>
      </div>
    </div>
  );
}
